import { Component, OnDestroy, ViewEncapsulation, AfterViewChecked, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { ModalService } from '@shared/services/modal.service';
import { UsersService } from '@shared/services/users.service';
import { UserPrimaryRoleConstants } from '@shared/constants/roles.constants';
import { SettingService } from '@shared/services/setting.service';
import { SettingModel } from '@shared/models/setting.model';

declare var $: any;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewChecked, OnDestroy {
  @ViewChild('helpButton') helpButton: HTMLButtonElement;

  private setterSubscription: Subscription;

  UserPrimaryRoleConstants = UserPrimaryRoleConstants;

  constructor(
    public translateService: TranslateService,
    private modalService: ModalService,
    public userService: UsersService,
    public settingService: SettingService,
  ) {}

  ngAfterViewChecked(): void { }

  ngOnDestroy(): void {
    this.setterSubscription?.unsubscribe();
  }

  useLang(lang) {
    this.translateService.use(lang);

    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);

    const event = new CustomEvent('onLanguageChange', { detail: lang });
    dispatchEvent(event);

    let settingToSave: SettingModel = this.settingService.setting;
    settingToSave.global.language = lang;

    this.setterSubscription?.unsubscribe();
    this.setterSubscription = this.settingService
      .saveSetting(settingToSave)
      .subscribe();
  }

  onSetting() {
    this.modalService.open('setting-modal');
  }

  refreshPage() {
    location.reload();
  }
}
